import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_TASKS_SAGA } from "../sagaTypes";
import { loaderAction, tasksAction, tasksCountAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/get_tasks`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetTasks(args) {
    const user = yield select(state => state.user);
    const currentEstablishment = yield select(state => state.currentEstablishment);
    const task_archive = yield select(state => state.task_archive);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('establishment', currentEstablishment);
        formData.append('archive', task_archive ? '1' : '0');

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            yield put(tasksAction(response.tasks));
            // Если получали текущие задачи, сохраняем их количество
            if (!task_archive) {
                yield put(tasksCountAction(response.tasks.length));
            }
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherGetTasks() {
    yield takeLatest(GET_TASKS_SAGA, workerGetTasks);
}